import { gql } from "@apollo/client";

const markCompositeInventoryOrderCartonAsReceivedMutation = gql`
  mutation ($inventoryOrderCartonIdentifier: String!) {
    markCompositeInventoryOrderCartonAsReceived(
      inventoryOrderCartonIdentifier: $inventoryOrderCartonIdentifier
    ) {
      errors {
        inventoryOrderCartonIdentifier
      }
      errorStatus
      updatedInventoryOrderCartons {
        id
        name
        quantity
        inventoryOrderItem {
          id
          gtin
          quantity
        }
        orderProductionJob {
          id
          totalProductVariantQuantity
          label
          index
          customizationAreas {
            method
            location
            artwork {
              id
              asset {
                url {
                  formatted
                }
              }
            }
          }
          hasLocalInventorySplit
          proofs {
            id
            asset {
              url {
                formatted
              }
            }
          }
          order {
            id
            includeCatalogInShipment
            isResolution
            orderNumber
            productionDate
            dropDeadDueBy
            directToGarmentAutomatable
            totalProductVariantQuantity
            totalShippingPrice {
              value
            }
            shipMissCosts {
              cost {
                formatted
              }
              date
            }
            productionNotesCollection {
                ... on FormattedNote {
                    author
                    createdAt
                    note
                }
                ... on UnformattedNote {
                    note
                }
            }
            productionStationAssignments {
              productionStation {
                name
              }
            }
            shippingTransactions {
              shippingMethod {
                name
              }
            }
            dueBy {
              dateTime
            }
            dueByLatest {
              dateTime
            }
            primaryCustomer {
              id
              name(format: FIRST_NAME_LAST_NAME)
              totalOrders
              totalOrderCount
              status
              insideBrandTagging
              businessUnit {
                id
                name
              }
            }
            productionJobs {
              id
            }
          }
          lineItemBreakdownByProduct {
            totalProductVariantQuantity
            product {
              id
              style
              fullDisplayName
            }
            lineItems {
              styleSubstitution {
                style
                color
              }
              primaryImage {
                asset {
                  url {
                    formatted
                  }
                }
              }
              id
              color {
                id
                name
                color {
                  formatted(format: HEX_WITH_POUND)
                }
              }
              sizes {
                id
                gtin
                quantity
                size {
                  id
                  code
                }
              }
            }
          }
        }
        received
      }
      succeeded
    }
  }
`;

export default markCompositeInventoryOrderCartonAsReceivedMutation;
